"use client"

import * as React from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { DayPicker } from "react-day-picker"

import { cn } from "@/lib/utils"
import { buttonVariants } from "@/components/ui/button"

export type CalendarProps = React.ComponentProps<typeof DayPicker>

function Calendar({
    className,
    classNames,
    showOutsideDays = true,
    ...props
}: CalendarProps) {
    return (
        <DayPicker
            showOutsideDays={showOutsideDays}
            className={cn("p-3", className)}
            classNames={{
                months: "flex flex-col sm:flex-row gap-4",
                month: "space-y-4",
                caption: "flex justify-center pt-1 relative items-center",
                caption_label: "text-sm font-medium",
                nav: "flex items-center space-x-1",
                nav_button: "h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100",
                nav_button_previous: "absolute left-1",
                nav_button_next: "absolute right-1",

                table: "w-full border-collapse",
                head_row: "flex",
                head_cell: "w-9 text-xs text-muted-foreground",
                row: "flex w-full mt-2",
                cell: "p-0 text-center",

                day: `
    h-9 w-9 rounded-md font-normal
    text-foreground
    hover:bg-accent hover:text-accent-foreground
  `,

                day_today: "bg-accent text-accent-foreground",

                day_selected:
                    "bg-primary text-primary-foreground hover:bg-primary",

                day_range_start:
                    "bg-primary text-primary-foreground rounded-l-md",

                day_range_end:
                    "bg-primary text-primary-foreground rounded-r-md",

                day_range_middle:
                    "bg-primary/20 text-foreground rounded-none",

                day_outside: "text-muted-foreground opacity-50",
                day_disabled: "text-muted-foreground opacity-40",
            }}


            components={{
                Chevron: ({ orientation }) => {
                    const Icon = orientation === "left" ? ChevronLeft : ChevronRight;
                    return <Icon className="h-4 w-4" />;
                },
            }}
            {...props}
        />
    )
}
Calendar.displayName = "Calendar"

export { Calendar }
